import React, {createRef} from "react"

import MenuItem from "../../../../project/submenu/submenu-item/more-popover/menu-item"
import MenuHelp from "../../../../project/submenu/submenu-item/more-popover/menu-help"
import ProjectCollectionView
    from "../../../../../../../core/manager/project-collection/project-collection-views/project-collection-view"

type Props = {
    className?  : string
    menuParams  : {
        view: ProjectCollectionView
    }
    hidePopover : func
}

export default class ProjectCollectionView_MoreMenu extends React.Component<Props> {

    private refInfo: any = createRef()

    constructor(props: Props) {
        super(props)
    }

    onCopyUrl = () => {
        this.props.hidePopover()
        this.props.menuParams.view.copyUrl()
    }

    onRename = () => {
        this.props.hidePopover()
        gd.projectCollectionViews.renameView(this.props.menuParams.view)
    }

    onDuplicate = () => {
        this.props.hidePopover()
        const baseView = this.props.menuParams.view
        gd.modals.project.newProjectCollectionView(baseView.name + ' copy', (values: any)=>{
            const newView = gd.projectCollectionViews.duplicateView(this.props.menuParams.view, values.name)
            gd.goTo(newView.url)
        })
    }

    onSetAsDefault =  () => {
        this.props.hidePopover()
        gd.projectCollectionViews.setDefaultView(this.props.menuParams.view)
    }

    onReset = () => {
        this.props.hidePopover()
        gd.projectCollectionViews.resetAppSettings(this.props.menuParams.view)
    }

    onDelete = () => {
        this.props.hidePopover()
        gd.projectCollectionViews.removeView(this.props.menuParams.view)
    }

    // set help message
    onSetInfoMessage = (message: string) => {
        this.refInfo.current.setMessage(message)
    }

    render() {
        const {view} = this.props.menuParams

        const classes = Classes("ui5-popover-menu with-help", this.props.className)

        return (
            <div className={classes}>
                <MenuItem icon="i5-pen"
                          label="Rename"
                          infoMessage="Rename view"
                          disabled={!view.availableActions.canRename}
                          onClick={this.onRename}
                          onSetInfoMessage={this.onSetInfoMessage}/>

                <MenuItem icon="i5-copy-link"
                          label="Copy URL"
                          infoMessage="Copy view URL to clipboard"
                          onClick={this.onCopyUrl}
                          onSetInfoMessage={this.onSetInfoMessage}/>

                <MenuItem icon="i5-clone"
                          label="Duplicate"
                          infoMessage="Duplicate view"
                          disabled={!view.availableActions.canDuplicate}
                          onClick={this.onDuplicate}
                          onSetInfoMessage={this.onSetInfoMessage}/>

                {view.availableActions.canResetToDefault &&
                    <MenuItem icon="i5-reset"
                              label="Reset to defaults"
                              infoMessage="Reset view settings to default values"
                              onClick={this.onReset}
                              onSetInfoMessage={this.onSetInfoMessage}/>}

                <MenuItem label="Set as default view"
                          infoMessage="Set as default view for this folder"
                          onClick={this.onSetAsDefault}
                          onSetInfoMessage={this.onSetInfoMessage} />

                <div className="separator"/>
                <MenuItem icon="i5-trash-alt"
                          label="Delete" infoMessage="Delete view"
                          disabled={!this.props.menuParams.view.availableActions.canDelete}
                          onClick={this.onDelete}
                          onSetInfoMessage={this.onSetInfoMessage}/>

                <MenuHelp ref={this.refInfo} defaultMessage="Mouse over menu item for help" />
            </div>
        )
    }
}
